import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { Button } from './ui/button';
import navLogo from '../images/logo/logo-ed-removebg-preview.png';

export function PublicNavbar() {
  const [isOpen, setIsOpen] = useState(false);
  const { theme, toggleTheme } = useTheme();

  const scrollTo = (id) => {
    setIsOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass bg-background/70 border-b border-border/40 transition-theme">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20 md:h-24">
          {/* Logo */}
          <Link to="/" className="flex items-center justify-center gap-3 md:gap-4" data-testid="nav-logo">
            {/* <img 
              src={navLogo} 
              alt="Eddy Dossou" 
              className="h-14 md:h-16 w-auto object-contain shrink-0"
            /> */}
            <div className="flex items-end gap-2 md:gap-3">
              <div className="relative w-7 h-8 md:w-9 md:h-10" aria-hidden="true">
                <span className="absolute top-0 left-0 font-serif text-2xl md:text-3xl leading-none text-foreground">E</span>
                <span className="absolute bottom-0 left-3 md:left-4 font-serif text-2xl md:text-3xl leading-none text-muted-foreground">D</span>
              </div>
              <div className="leading-none">
                <p className="font-serif text-lg md:text-2xl font-medium tracking-tight text-foreground">Eddy Dossou</p>
                <p className="text-[10px] md:text-xs uppercase tracking-[0.28em] text-muted-foreground">Photographe</p>
              </div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <button 
              onClick={() => scrollTo('gallery')} 
              className="text-sm font-medium tracking-wide uppercase text-muted-foreground hover:text-foreground transition-colors"
              data-testid="nav-gallery"
            >
              Galerie
            </button>
            <button 
              onClick={() => scrollTo('about')} 
              className="text-sm font-medium tracking-wide uppercase text-muted-foreground hover:text-foreground transition-colors"
              data-testid="nav-about"
            >
              À propos
            </button>
            <button 
              onClick={() => scrollTo('contact')} 
              className="text-sm font-medium tracking-wide uppercase text-muted-foreground hover:text-foreground transition-colors"
              data-testid="nav-contact"
            >
              Contact
            </button>
            
            {/* Theme Toggle */}
            <Button 
              variant="ghost" 
              size="icon"
              onClick={toggleTheme}
              aria-label="Toggle theme"
              data-testid="theme-toggle"
              className="rounded-full"
            >
              {theme === 'dark' ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="flex md:hidden items-center gap-2">
            <Button 
              variant="ghost" 
              size="icon"
              onClick={toggleTheme}
              aria-label="Toggle theme"
              data-testid="theme-toggle-mobile"
              className="rounded-full"
            >
              {theme === 'dark' ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
            </Button>
            <Button 
              variant="ghost" 
              size="icon"
              onClick={() => setIsOpen(!isOpen)}
              aria-label="Menu"
              data-testid="mobile-menu-toggle"
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4 border-t border-border/40">
            <div className="flex flex-col gap-4">
              <button 
                onClick={() => scrollTo('gallery')} 
                className="text-sm font-medium tracking-wide uppercase text-muted-foreground hover:text-foreground transition-colors text-left"
                data-testid="mobile-nav-gallery"
              >
                Galerie
              </button>
              <button 
                onClick={() => scrollTo('about')} 
                className="text-sm font-medium tracking-wide uppercase text-muted-foreground hover:text-foreground transition-colors text-left"
                data-testid="mobile-nav-about"
              >
                À propos
              </button>
              <button 
                onClick={() => scrollTo('contact')} 
                className="text-sm font-medium tracking-wide uppercase text-muted-foreground hover:text-foreground transition-colors text-left"
                data-testid="mobile-nav-contact"
              >
                Contact
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
